import { memo } from "react"
import FormTextInput from "../../FormTextInput"
import { CSSTransition } from "react-transition-group"
import { ClipBoardSingle, Trash } from "../../svgs/SVGS"
import Button from "../../Button/Index"
import Paste from "../../Paste"

const PasteElement = memo(({onClick}) => <Paste onClick={onClick} icon={<ClipBoardSingle/>} text="Paste"/>)

const RemoveFromList = memo(({transitionIn, onClick}) =>
<CSSTransition
  in={transitionIn}
  timeout={300}
  classNames="fade"
  unmountOnExit
>
  <div onClick={onClick}><Trash/></div>
</CSSTransition>)

const WhitelistBody = memo(({ips, loading, disabled, error, sideSlotCB, inputInnerCB, buttonText, addNewItemCB, updateIPCB}) => 
  <div className={`cc-whitelist${ips.length === 1 ? ' cc-whitelist__multi' : '' }`}>
    <div className='cc-whitelist-details'>
    Add up to 5 IPs to whitelist your customized automation tools, those IPs will not be blocked by Bot Zapping.
    </div>
    <div className='cc-whitelist-details'>
    Please note that IP ranges are not supported.
</div>
    <section className={`cc-whitelist-ips`}>
      {ips.map((ip, index) => 
        <FormTextInput 
          key={index} 
          placeholder="Paste IP address here" 
          value={ip} 
          alwaysShowInner={true} 
          sideSlot={<RemoveFromList transitionIn={ips.length > 1} onClick={() => sideSlotCB(index)}/>}
          inputInner={<PasteElement onClick={() => inputInnerCB(index)}/>}
          setValueCB={(value) => updateIPCB(index, value)}
          loading={loading}
        />)
      }
    </section>
    <div className="cc-whitelist-buttons">
      <Button 
        className="cc-whitelist-button"
        loading={loading}
        onClick={addNewItemCB}
        content={buttonText}
        disabled={disabled}
        errorMessage={error}
      />
    </div>    
  </div>)

export default WhitelistBody